import { SET_TESTING_OPTIONS } from '../actions/TestingOptionsActions'

const initialState = {
  simulateInternal: false
}

const TestingOptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TESTING_OPTIONS:
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export default TestingOptionsReducer
